import { LitElement, html, css } from 'lit'

customElements.define('k-image', class extends LitElement{

    static styles = css`
        :host {
            display: inline-block;
            position:relative;
            max-height: 70vh;
        }

        ::slotted(img) {
            max-height: 100%;
            max-width: 100%;
            object-fit: cover;
            height: var(--img-height, unset) !important;
        }
    `

    render(){return html`
        <slot></slot>
    `}

})

export default customElements.get('k-image')